import { gql } from '@apollo/client'

export default gql(`
query listPublishingGroups($project: String){
    listPublishingGroups(project: $project){
        items{
          id
          name
          status
          isEnvironment
          isDefault
          priority
        }
      }
}`)
